export default __webpack_public_path__ + "images/logo-02.073fabe1d374afe55fcb983a7232cdc8.png";